module.exports = __webpack_public_path__ + "img/icons8-close.4d7fd690.svg";